angular.module('picmonicng').factory('WorkflowResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v3/workflows/:workflow_id/:action',
      { workflow_id: '@workflow_id', action: '@action' },
      {
        update: { method: 'PUT' },
        validate: {
          method: 'POST',
          isArray: true,
          params: { action: 'validate' },
        },
        batch: { method: 'POST', params: { action: 'batch' } },
        publish: { method: 'POST', params: { action: 'publish' } },
        merge: { method: 'POST', params: { action: 'merge' } },
        version: { method: 'POST', params: { action: 'version' } },
        sendBack: { method: 'POST', params: { action: 'sendback' } },
        myQueue: {
          method: 'GET',
          params: { action: 'myqueue', user_id: '@user_id', type: '@type' },
          isArray: true
        },
        getType: {
          method: 'GET',
          url: '/api/v3/workflows/:type/:type_id',
          params: { type: '@type', type_id: '@type_id' },
        },
      }
    );
  },
]);
